<template>
  <div class="login login-register">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="login-box card">
      <div class="card-body">
        <h3 class="box-title m-b-20">{{ page_title }}</h3>

        <div v-if="!expired">

          <span v-if="name_first">
            Please enter a new password for your Verida account, {{this.name_first}}.
          </span>

          <div class="form-group">
            <div class="col-xs-12">
              <input v-model="password" :type="'password'" autocomplete="off" class="form-control form-control-sm"
                     placeholder="Enter new password" type="text">
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-12">
              <input v-model="confirm_password" :type="'password'" autocomplete="off"
                     class="form-control form-control-sm"
                     placeholder="Confirm new password" type="text">
            </div>
          </div>

          <div class="col-xs-12 p-b-20 submit-button">
            <button v-on:click="reset()" class="btn btn-block btn-lg btn-info btn-rounded">Reset</button>
          </div>
        </div>
        <div v-if="expired">
          <span>Sorry, your link has expired. Click <a href="/#/send-reset-link">here</a> to get a new link.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Reset Password',
    },
    name: 'ResetPassword',
    data () {
      return {
        page_title: 'Reset Password',
        data: {},
        username: null,
        password: null,
        isLoading: false,
        sent: false,
        confirm_password: null,
        id_user: null,
        code: null,
        name_first: null,
        expired: false,
      }
    },
    components: {
      Loading,
    },
    methods: {
      getFirstName: function () {
        this.isLoading = true

        this.$http
          .get(process.env.API_BASE_URL + 'users/' + this.id_user + '/?type=first_name&code=' + this.code,
            {
              headers: {}
            }
          )
          .then(response => {
            console.log(response.data)
            this.name_first = response.data.name_first
          })
          .catch(error => {
            console.log(error.response)

            error = error.response.data
            if ('non_field_errors' in error) {
              error = error['non_field_errors'][0]
            } else {
              if (Array.isArray(error)) {
                error = error[0]
              } else {
                let name = Object.keys(error)[0]
                error = error[name][0].replace('This field', this.field_name[name])
                error = error.replace('this field', this.field_name[name])
                error = error.replace('Enter a valid email address.', 'Invalid email address.')
              }
            }

            if (error == 'Code expired.') {
              this.expired = true
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      reset: function () {
        if (!this.password || this.password.length == 0) {
          this.showToastError('Please enter a valid password.')
          return
        }
        if (!this.confirm_password || this.confirm_password.length == 0) {
          this.showToastError('Passwords don\'t match. Please try again.')
          return
        }
        if (this.password != this.confirm_password) {
          this.showToastError('Passwords don\'t match. Please try again.')
          return
        }

        this.isLoading = true

        this.$http
          .patch(process.env.API_BASE_URL + 'users/' + this.id_user + '/?type=reset_password', {
              password: this.password,
              code: this.code
            },
            {
              headers: {}
            }
          )
          .then(response => {
            console.log(response.data)
            this.showToastError('Your driver account password was changed successfully. Please close this window and return to your driver app.')
            this.$router.push('/login/')
          })
          .catch(error => {
            console.log(error.response)

            error = error.response.data
            if ('non_field_errors' in error) {
              error = error['non_field_errors'][0]
            } else {
              if (Array.isArray(error)) {
                error = error[0]
              } else {
                let name = Object.keys(error)[0]
                error = error[name][0].replace('This field', this.field_name[name])
                error = error.replace('this field', this.field_name[name])
                error = error.replace('Enter a valid email address.', 'Invalid email address.')
              }
            }

            this.showToastError(error)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    mounted: function () {
      $('body').addClass('logged-out')
      this.id_user = this.$route.params.id_user
      this.code = this.$route.params.code
      this.getFirstName()
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }

  textarea {
    width: 100%;
  }
</style>
<style>

  body.logged-out .page-wrapper {
    margin-left: 0px;
  }

  body.logged-out .sidebartoggler, body.logged-out .topbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue